import React from "react";
import AgendarCita from "../components/AgendarCita";
import SolicitudesPendientes from "../components/SolicitudesPendientes";
import DetallesCita from "../components/DetallesCita";

const PaginaSolicitudesPendientes = () => {
  return (
    <div>
      <h1>Solicitudes Pendientes</h1>
      <SolicitudesPendientes />
      <h1>Detalles de la cita</h1>
      <DetallesCita />
      <h1>Agendar cita</h1>
      <AgendarCita />
    </div>
  );
};

export default PaginaSolicitudesPendientes;
